<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:4px;">
    <h2 style="margin:0; font-size:20px; font-weight:600; color: #1976d2">
        CAFAE - ELECCIONES 2026 - 2028
    </h2>
    <button mat-icon-button (click)="cerrar()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="visor-dialog">

    <!-- Menú izquierdo -->
    <aside class="sidebar">
        <mat-nav-list>
            <a mat-list-item *ngFor="let doc of documentos" (click)="seleccionarDocumento(doc)">
                {{ doc.titulo }}
            </a>
        </mat-nav-list>
    </aside>

    <!-- Contenido -->
    <section class="contenido">
        <img *ngIf="documentoSeleccionado" [src]="documentoSeleccionado.uri" [alt]="documentoSeleccionado.titulo"
            (click)="abrirLink()" class="imagen-comunicado">
    </section>

</mat-dialog-content>